import styled from 'styled-components';
import { v2Color } from '@theme/v2';

export const CtaWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

export const CtaLabel = styled.span`
  color: rgb(112, 112, 112);
  font-size: 13px;
`;

export const ReachOutButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  border: 0;
  color: ${v2Color('#006169', 'text')};
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
`;

export const RequestedChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 6px 10px;
  background: ${v2Color('#E1F2F0')};
  color: ${v2Color('#006169', 'text')};
  border-radius: 24px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
`;

export const ChipIcon = styled.span`
  display: inline-grid;
  place-content: center;
`;

export const ChipLabel = styled.span``;
